"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.projection = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
const P = __importStar(require("proj4leaflet"));
const useInnerCoordinates_1 = require("./useInnerCoordinates");
//@ts-ignore
const a = P.test;
if (a == 'asdf')
    console.log("log it is");
else
    console.log("log it is not", a);
exports.projection = {
    crs: new leaflet_1.default.Proj.CRS(useInnerCoordinates_1.innerProjection.code, useInnerCoordinates_1.innerProjection.alias, {
        resolutions: [
            4891.96999883583,
            2445.98499994708,
            1222.99250010583,
            611.496250052917,
            305.748124894166,
            152.8740625,
            76.4370312632292,
            38.2185156316146,
            19.1092578131615,
            9.55462890525781,
            4.77731445262891,
            2.38865722657904,
            1.19432861315723,
            0.597164306578613,
            0.298582153289307,
            0.149291076644653,
            0.0746455383223265,
            0.0373227691611632,
        ]
    }),
    transform: (coordinates) => {
        return [coordinates[0], coordinates[1]];
    }
};
